import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=0d594abc&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d594abc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d594abc')) {
      api.createRecord('0d594abc', component.options)
    } else {
      api.reload('0d594abc', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=0d594abc&scoped=true&", function () {
      api.rerender('0d594abc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2KaeWOmLV6jQJ/JS/comp/Accordion.vue"
export default component.exports